import { Check } from 'lucide-react';

const standardFeatures = [
  'Identity Verification',
  'Criminal Record Check',
  'Employment History',
  'Education Verification',
  'Reference Check (2 refs)',
];

const enhancedFeatures = [
  'Everything in Standard',
  'Financial Background Check',
  'Social Media Screening',
  'Address Verification',
  'Reference Check (4 refs)',
  'Court Record Search',
  'Directorship & Conflict Check',
];

export default function PricingCtaSection() {
  return (
    <section className="w-full bg-[#F5F5F5] px-4 md:px-6 lg:px-10 py-16 md:py-20 lg:py-24">
      <div className="max-w-[1400px] w-full mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">
          {/* Left: Pricing */}
          <div className="w-full lg:w-1/2">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-8 md:mb-10">
              Our Pricing Options
            </h2>

            <div className="flex flex-col sm:flex-row gap-4 md:gap-6">
              {/* Standard Check Card */}
              <div className="flex-1 bg-white rounded-2xl lg:rounded-3xl p-6 md:p-8 flex flex-col">
                <p className="text-gray-500 text-sm font-medium mb-2">Standard Check</p>
                <p className="text-[#FF6B35] text-3xl md:text-4xl font-bold mb-6">{'\u20A6'}56,900</p>
                <ul className="space-y-3 mb-8 flex-1">
                  {standardFeatures.map((feature, i) => (
                    <li key={i} className="flex items-start gap-2.5">
                      <div className="w-5 h-5 bg-[#FF6B35]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Check className="w-3 h-3 text-[#FF6B35]" />
                      </div>
                      <span className="text-gray-700 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
                <button className="w-full bg-black text-white py-3 rounded-full text-sm font-medium hover:bg-gray-900 transition-colors">
                  Proceed
                </button>
              </div>

              {/* Enhanced Check Card */}
              <div className="flex-1 bg-[#14171A] rounded-2xl lg:rounded-3xl p-6 md:p-8 flex flex-col">
                <p className="text-gray-400 text-sm font-medium mb-2">Enhanced Check</p>
                <p className="text-[#FF6B35] text-3xl md:text-4xl font-bold mb-6">{'\u20A6'}78,900</p>
                <ul className="space-y-3 mb-8 flex-1">
                  {enhancedFeatures.map((feature, i) => (
                    <li key={i} className="flex items-start gap-2.5">
                      <div className="w-5 h-5 bg-[#FF6B35]/20 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Check className="w-3 h-3 text-[#FF6B35]" />
                      </div>
                      <span className="text-gray-300 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
                <button className="w-full bg-[#FF6B35] text-white py-3 rounded-full text-sm font-medium hover:bg-[#ff5722] transition-colors">
                  Proceed
                </button>
              </div>
            </div>
          </div>

          {/* Right: CTA */}
          <div className="w-full lg:w-1/2 flex">
            <div className="w-full bg-[#14171A] rounded-2xl lg:rounded-3xl p-8 md:p-10 lg:p-12 flex flex-col justify-between overflow-hidden relative">
              {/* Decorative gradient */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-[#FF6B35]/5 rounded-full blur-3xl" />

              <div className="relative z-10">
                <h3 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4 md:mb-6 leading-tight">
                  Ready to verify<br />your next hire?
                </h3>
                <p className="text-gray-400 text-sm md:text-base leading-relaxed mb-8 max-w-[400px]">
                  Get started today with Podus Checker and ensure your hiring decisions are backed by thorough, accurate background verification.
                </p>

                <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
                  <button className="bg-[#FF6B35] text-white px-6 py-3 rounded-full text-sm font-medium hover:bg-[#ff5722] transition-colors whitespace-nowrap">
                    Run a Background Check
                  </button>
                  <button className="border border-[#FF6B35] text-[#FF6B35] px-6 py-3 rounded-full text-sm font-medium hover:bg-[#FF6B35]/10 transition-colors whitespace-nowrap">
                    Contact our Associate
                  </button>
                </div>
              </div>

              {/* Bottom illustration - person silhouette with laptop */}
              <div className="relative z-10 mt-8 md:mt-12 flex justify-end">
                <div className="w-48 h-32 md:w-64 md:h-40 bg-gradient-to-t from-[#FF6B35]/10 to-transparent rounded-2xl flex items-end justify-center overflow-hidden">
                  <svg
                    viewBox="0 0 200 120"
                    fill="none"
                    className="w-full h-full opacity-30"
                  >
                    {/* Simple person with laptop silhouette */}
                    <ellipse cx="100" cy="115" rx="60" ry="8" fill="#FF6B35" opacity="0.3" />
                    <rect x="70" y="80" width="60" height="5" rx="2" fill="#FF6B35" opacity="0.5" />
                    <rect x="75" y="55" width="50" height="25" rx="3" fill="#FF6B35" opacity="0.4" />
                    <circle cx="100" cy="40" r="15" fill="#FF6B35" opacity="0.4" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
